import { AccountCircleRounded, ExitToApp  } from '@material-ui/icons';
// import brandLogo from '../assets/images/flipkoins_dark_logo.png';
import brandLogo from '../assets/images/logo/flipkoins-logo.png';

 export const NavItems = {
      profile: {
          icon: AccountCircleRounded,
          link: "",
          text: "Profile",
          subMenu: [
            {
              id: 1,
              icon: AccountCircleRounded,
              link: "/profile",
              text: "Profile",
            },
            {
              id: 3,
              icon: ExitToApp,
              link: "",
              text: "Sign out",
            },
          ],
      },
   };

   export const NavBrand = {
      brandName: "",
      url: "/home",
      logo: {
          dark: brandLogo
      }
   }